const data = {
  pageName: "Koftis",
  pageType: "PREPAY",
  services: {
    submitBundle: {
      url: "koftis/submitBundle",
      params: {}
    },
    getBundles: {
      url: "koftis/bundles",
      params: {}
    },
    getBalance: {
      url: "koftis/balance",
      params: {}
    },
    assetVerify: {
      url: "koftis/assetVerify",
      params: {}
    },
    translations: {
      url: "koftis/translations",
      params: {}
    }
  }
};

exports.data = data;
